import { z } from 'zod';

import { Option } from '../../types/Option';

const componentTypes = [
    'battery',
    'bus',
    'capacitor',
    'charger',
    'breaker',
    'controller',
    'combinerBox',
    'contactor',
    'converter',
    'currentTransducer',
    'custom',
    'diode',
    'disconnect',
    'fuelCell',
    'fuse',
    'generator',
    'grounding',
    'hvac',
    'load',
    'light',
    'meter',
    'motor',
    'other',
    'panel',
    'powerDistributionUnit',
    'precharge',
    'rapidShutdownDevice',
    'connector',
    'reference',
    'solar',
    'solution',
    'transferSwitch',
    'transformer',
    'utility',
    'voltageTransducer',
    'hydro',
    'wind',
    'cable',
    'software',
] as const;

export type ComponentType = (typeof componentTypes)[number];

const options = [
    { value: 'battery', label: 'Battery' },
    { value: 'capacitor', label: 'Capacitor' },
    { value: 'charger', label: 'Charger for e-mobility' },
    { value: 'breaker', label: 'Circuit Breaker' },
    { value: 'bus', label: 'Electrical Bus' },
    { value: 'controller', label: 'Controller' },
    { value: 'combinerBox', label: 'Combiner Box' },
    { value: 'contactor', label: 'Contactor' },
    { value: 'converter', label: 'Converter' },
    { value: 'currentTransducer', label: 'Current Transducer' },
    { value: 'custom', label: 'Custom' },
    { value: 'diode', label: 'Diode' },
    { value: 'disconnect', label: 'Disconnect' },
    { value: 'fuelCell', label: 'Fuel Cell' },
    { value: 'fuse', label: 'Fuse' },
    { value: 'generator', label: 'Generator' },
    { value: 'grounding', label: 'Grounding' },
    { value: 'hvac', label: 'HVAC' },
    { value: 'load', label: 'Load' },
    { value: 'light', label: 'Light' },
    { value: 'meter', label: 'Meter' },
    { value: 'motor', label: 'Motor' },
    { value: 'other', label: 'Other' },
    { value: 'panel', label: 'Panel' },
    { value: 'connector', label: 'Connector' },
    { value: 'powerDistributionUnit', label: 'Power Distribution Unit' },
    { value: 'precharge', label: 'Precharge' },
    { value: 'rapidShutdownDevice', label: 'Rapid Shutdown Device' },
    { value: 'reference', label: 'Reference' },
    { value: 'solar', label: 'Solar' },
    { value: 'solution', label: 'Solution' },
    { value: 'transferSwitch', label: 'Transfer switch' },
    { value: 'transformer', label: 'Transformer' },
    { value: 'utility', label: 'Utility' },
    { value: 'voltageTransducer', label: 'Voltage Transducer' },
    { value: 'hydro', label: 'Hydro' },
    { value: 'wind', label: 'Wind' },
    { value: 'cable', label: 'Cable' },
    { value: 'software', label: 'Software' },
] as Option<ComponentType>[];

export const ComponentType = {
    validator: z.enum(componentTypes),
    options,
};
